import { gql } from '@apollo/client';

const FRAGMENT_DEALER_FIELDS = gql`
  fragment FragmentDealerFields on Dealer {
    dealerId
    matPrimaryCode
    kvpsPartnerKey
    kvpsId
    country
    name
    address
    latitude
    longitude
    services
    distance
    phone
    additionalData {
      displayName
      locationName
      locationImage
      additionalServices
      additionalUrl
    }
    openingHours {
      departments {
        id
        departmentName
        openingHours {
          id
          open
          timeRanges {
            openTime
            closeTime
          }
        }
      }
    }
  }
`;

export const BY_TERM = gql`
  query Dealer($searchTerm: String!, $country: String, $services: String) {
    dealersByTerm(searchTerm: $searchTerm, limit: 20, country: $country, serviceFilter: $services) {
      dealers {
        ...FragmentDealerFields
      }
      meta {
        resultCount
      }
    }
  }
  ${FRAGMENT_DEALER_FIELDS}
`;

export const BY_DEALER_ID = gql`
  query Dealer($dealerId: String!) {
    dealerById(dealerId: $dealerId) {
      ...FragmentDealerFields
    }
  }
  ${FRAGMENT_DEALER_FIELDS}
`;

export const BY_ADDRESS = gql`
  query Dealer(
    $searchTerm: String!
    $radius: Int
    $userLat: Float
    $userLng: Float
    $country: String
    $services: String
  ) {
    dealersByAddress(
      searchTerm: $searchTerm
      radius: $radius
      userLat: $userLat
      userLng: $userLng
      country: $country
      serviceFilter: $services
    ) {
      dealers {
        ...FragmentDealerFields
      }
      meta {
        resultCount
        searchCenter
      }
    }
  }
  ${FRAGMENT_DEALER_FIELDS}
`;

export const BY_GEOLOCATION = gql`
  query Dealer(
    $lat: Float!
    $lng: Float!
    $userLat: Float
    $userLng: Float
    $radius: Int
    $country: String
    $services: String
  ) {
    dealersByGeoLocation(
      lat: $lat
      lng: $lng
      userLat: $userLat
      userLng: $userLng
      radius: $radius
      limit: 20
      country: $country
      serviceFilter: $services
    ) {
      dealers {
        ...FragmentDealerFields
      }
      meta {
        resultCount
        searchRadius
      }
    }
  }
  ${FRAGMENT_DEALER_FIELDS}
`;

export const BY_GEO_AREA = gql`
  query Dealer(
    $northEastLat: Float!
    $northEastLng: Float!
    $southWestLat: Float!
    $southWestLng: Float!
    $userLat: Float
    $userLng: Float
    $country: String
    $services: String
  ) {
    dealersByGeoArea(
      northEastLat: $northEastLat
      northEastLng: $northEastLng
      southWestLat: $southWestLat
      southWestLng: $southWestLng
      userLat: $userLat
      userLng: $userLng
      country: $country
      serviceFilter: $services
    ) {
      dealers {
        ...FragmentDealerFields
      }
      meta {
        resultCount
      }
    }
  }
  ${FRAGMENT_DEALER_FIELDS}
`;
